import Location from "@/scenes/location";
import GameApp from "../../../index";
import "@/gui/components/room-access-screen";
import { RoomAccessScreen } from "@/gui/components/room-access-screen";

export class AccessHandler {
  static async handle(data: {
    action: any;
    users: any;
    userId: any;
    npcs: any;
  }) {
    const { action, users, userId, npcs } = data;

    const roomAccessScreen = document.querySelector(
      "room-access-screen"
    ) as RoomAccessScreen;

    switch (action) {
      case "join":
        roomAccessScreen?.hide();
        await this.handleJoin(users);

        if (npcs && npcs.length > 0) {
          await this.addNPCS(npcs);
        }
        break;

      case "leave":
        this.handleLeave(userId);
        break;

      case "password":
        roomAccessScreen?.open();
        roomAccessScreen?.setRoom("1", "ffff");
        break;

      case "wrong-password":
        roomAccessScreen?.showError();
        break;
    }
  }

  private static async handleJoin(users: any) {
    const currentScene = GameApp.game.currentScene as Location;

    if (currentScene && currentScene.locationInfo)
      currentScene.locationInfo.usersInRoom = users.length;

    if (currentScene) await currentScene?.loadLookResources(users);

    currentScene?.addPlayers(users);
  }

  private static async addNPCS(npcs: any) {
    const currentScene = GameApp.game.currentScene as Location;
    currentScene?.addNPCS(npcs);
  }

  private static handleLeave(userId: string) {
    const activeScene = GameApp.game.currentScene as Location;
    activeScene.removePlayer(userId);
    activeScene.locationInfo.usersInRoom -= 1;
  }
}
